import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';

// Each programming course with its detail-page slug
const programmingCourses = [
  { title: 'Python Training',          slug: 'python-training' },
  { title: 'Python With AI Training',  slug: 'python-ai-training' },
  { title: 'Python With ML Training',  slug: 'python-ml-training' },
  { title: 'Machine Learning',         slug: 'machine-learning' },
  { title: 'Android With IOT Training',slug: 'android-iot-training' },
  { title: 'IOT Training',             slug: 'iot-training' },
  { title: 'Android Training',         slug: 'android-training' },
  { title: 'iPhone Training',          slug: 'iphone-training' },
  { title: 'PHP/MySQL Training',       slug: 'php-mysql-training' },
  { title: 'ASP.Net Training',         slug: 'aspnet-training' },
  { title: 'Java Training',            slug: 'java-training' },
  { title: 'Odoo Training',            slug: 'odoo-training' },
  { title: 'Big Data Training',        slug: 'big-data-training' },
  { title: 'Hadoop Training',          slug: 'hadoop-training' },
  { title: 'Magento Training',         slug: 'magento-training' },
  { title: 'WordPress Training',       slug: 'wordpress-training' },
  { title: 'CodeIgniter Training',     slug: 'codeigniter-training' },
  { title: 'Drupal Training',          slug: 'drupal-training' },
  { title: 'Joomla Training',          slug: 'joomla-training' },
  { title: 'Silverlight Training',     slug: 'silverlight-training' },
  { title: 'C Language Training',      slug: 'c-language-training' },
  { title: 'C++ Language Training',    slug: 'cpp-language-training' },
  { title: 'Software Testing',         slug: 'software-testing' },
  { title: 'Digital Marketing',        slug: 'digital-marketing-prog' },
];

const nonProgrammingCourses = [
  { title: 'Web Design Training',           slug: 'web-design-training',           sub: ['HTML5/CSS3 & Responsive', 'JavaScript / jQuery', 'Adobe Photoshop / Fireworks'] },
  { title: 'Graphics Design Training',      slug: 'graphics-design-training',      sub: ['Adobe Photoshop / Fireworks', 'Adobe Flash', 'CorelDRAW Graphics', 'Adobe Illustrator'] },
  { title: 'SEO Training',                  slug: 'seo-training',                  sub: [] },
  { title: 'Digital Marketing',             slug: 'digital-marketing-nonprog',     sub: [] },
  { title: 'Business Development Training', slug: 'business-development-training', sub: [] },
];

const specialTraining = [
  { title: 'Free Training',      slug: 'free-training',      sub: [] },
  { title: 'Weekend Training',   slug: 'weekend-training',   sub: ['PHP Weekend Training', '.Net Weekend Training', 'Java Weekend Training', 'Android Weekend Training'] },
  { title: 'Corporate Training', slug: 'corporate-training', sub: [] },
];

function DropItem({ item, basePath }) {
  const to = item.slug ? `/it-training/course/${item.slug}` : basePath;
  return (
    <li className={item.sub && item.sub.length ? 'ith__has-sub' : ''}>
      <Link to={to} className="ith__dropdown-link">{item.title}</Link>
      {item.sub && item.sub.length > 0 && (
        <ul className="ith__sub-dropdown">
          {item.sub.map(s => (
            <li key={s}><Link to={to} className="ith__dropdown-link">{s}</Link></li>
          ))}
        </ul>
      )}
    </li>
  );
}

function ITTrainingHeader() {
  const [openMenu, setOpenMenu] = useState(null);
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleMouseEnter = (name) => setOpenMenu(name);
  const handleMouseLeave = () => setOpenMenu(null);
  const handleClick = (name) => setOpenMenu(prev => prev === name ? null : name);
  const closeAll = () => { setOpenMenu(null); setMobileOpen(false); };

  return (
    <header className="ith">
      {/* ── Top bar with social icons ── */}
      <div className="ith__top">
        <div className="ith__top-inner">
          <span className="ith__top-tagline">Vedanskrix — Empowering Ideas. Enabling Growth.</span>
          <div className="ith__top-socials">
            <a href="https://wa.me/918758637022" className="ith__social ith__social--wa" target="_blank" rel="noreferrer" aria-label="WhatsApp">
              <svg viewBox="0 0 24 24" fill="currentColor" width="15" height="15"><path d="M12 5.2a6.55 6.55 0 0 0-5.66 9.86L5.5 18.8l3.84-.82A6.55 6.55 0 1 0 12 5.2Zm3.1 9.3c-.13.36-.75.67-1.03.71-.27.04-.62.07-1-.06-.23-.08-.53-.18-.92-.35-1.61-.7-2.66-2.34-2.74-2.45-.08-.11-.65-.86-.65-1.64 0-.78.41-1.16.56-1.32.15-.16.33-.2.44-.2h.31c.1 0 .24-.04.37.28.14.33.47 1.13.51 1.21.04.08.07.17.01.28-.05.11-.08.18-.17.27-.08.1-.18.22-.25.29-.08.08-.17.17-.07.34.1.17.44.73.95 1.18.64.57 1.17.75 1.34.83.17.08.27.07.37-.04.1-.11.4-.47.5-.63.1-.16.2-.13.34-.08.14.05.88.42 1.03.5.15.08.25.12.29.19.04.07.04.4-.09.76Z"/></svg>
            </a>
            <a href="#" className="ith__social ith__social--fb" aria-label="Facebook" onClick={e => e.preventDefault()}>
              <svg viewBox="0 0 24 24" fill="currentColor" width="15" height="15"><path d="M13.2 18.5v-5.6h2l.3-2.3h-2.3V9.1c0-.67.19-1.12 1.15-1.12h1.23V5.92c-.21-.03-.95-.09-1.8-.09-1.79 0-3.01 1.09-3.01 3.09v1.72H9v2.3h2.02v5.56h2.18Z"/></svg>
            </a>
            <a href="#" className="ith__social ith__social--ig" aria-label="Instagram" onClick={e => e.preventDefault()}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" width="15" height="15"><rect x="6.2" y="6.2" width="11.6" height="11.6" rx="3"/><circle cx="12" cy="12" r="2.9"/><circle cx="16.1" cy="7.9" r="0.7" fill="currentColor" stroke="none"/></svg>
            </a>
            <a href="#" className="ith__social ith__social--yt" aria-label="YouTube" onClick={e => e.preventDefault()}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" width="15" height="15"><path d="M18.2 9.2c-.14-.54-.57-.97-1.11-1.11C16.1 7.8 12 7.8 12 7.8s-4.1 0-5.1.3c-.54.14-.97.57-1.11 1.11-.3 1-.3 2.8-.3 2.8s0 1.8.3 2.8c.14.54.57.97 1.11 1.11 1 .3 5.1.3 5.1.3s4.1 0 5.1-.3c.54-.14.97-.57 1.11-1.11.3-1 .3-2.8.3-2.8s0-1.8-.3-2.8Z"/><path d="m10.6 14.4 3.4-2.4-3.4-2.4v4.8Z" fill="currentColor" stroke="none"/></svg>
            </a>
            <a href="#" className="ith__social ith__social--li" aria-label="LinkedIn" onClick={e => e.preventDefault()}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" width="15" height="15"><path d="M8.2 10.1v7.1M8.2 7.4h.01M11.2 10.1v7.1M11.2 12.9c0-1.7 1.1-2.8 2.6-2.8 1.5 0 2.2 1 2.2 2.9v4.2"/></svg>
            </a>
          </div>
        </div>
      </div>

      {/* ── Logo row ── */}
      <div className="ith__main">
        <div className="ith__main-inner">
          <Link to="/" className="ith__logo-wrap" onClick={closeAll}>
            <img src="/logo.jpg" alt="Vedanskrix" className="ith__logo" />
            <div className="ith__logo-text">
              <span className="ith__logo-name">VEDANSKRIX</span>
              <span className="ith__logo-sub">IT Training &amp; Job Placement</span>
            </div>
          </Link>
          <button
            className={mobileOpen ? 'ith__toggle active' : 'ith__toggle'}
            onClick={() => setMobileOpen(v => !v)}
            aria-label="Toggle menu"
            type="button"
          >
            <span/><span/><span/>
          </button>
        </div>
      </div>

      {/* ── Nav bar ── */}
      <nav className={mobileOpen ? 'ith__nav ith__nav--open' : 'ith__nav'} aria-label="IT Training navigation">
        <div className="ith__nav-inner">

          {/* 1. Home */}
          <NavLink to="/it-training" end className={({isActive}) => isActive ? 'ith__link active' : 'ith__link'} onClick={closeAll}>
            Home
          </NavLink>

          {/* 2. Programming Courses */}
          <div
            className="ith__drop-wrap"
            onMouseEnter={() => handleMouseEnter('prog')}
            onMouseLeave={handleMouseLeave}
          >
            <button
              type="button"
              className={openMenu === 'prog' ? 'ith__link ith__link--drop active' : 'ith__link ith__link--drop'}
              onClick={() => handleClick('prog')}
            >
              Programming Courses <span className="ith__caret">▾</span>
            </button>
            <div className={openMenu === 'prog' ? 'ith__dropdown ith__dropdown--wide open' : 'ith__dropdown ith__dropdown--wide'}>
              <div className="ith__dropdown-cols">
                <ul className="ith__dropdown-list">
                  <li>
                    <Link to="/it-training/programming" className="ith__dropdown-link ith__dropdown-link--all" onClick={closeAll}>
                      → View All Programming Courses
                    </Link>
                  </li>
                </ul>
                {[0, 1, 2].map(col => (
                  <ul key={col} className="ith__dropdown-list">
                    {programmingCourses.slice(col * 8, col * 8 + 8).map(c => (
                      <li key={c.slug}>
                        <Link to={`/it-training/course/${c.slug}`} className="ith__dropdown-link" onClick={closeAll}>{c.title}</Link>
                      </li>
                    ))}
                  </ul>
                ))}
              </div>
            </div>
          </div>

          {/* 3. Non-Programming Courses */}
          <div
            className="ith__drop-wrap"
            onMouseEnter={() => handleMouseEnter('nonprog')}
            onMouseLeave={handleMouseLeave}
          >
            <button
              type="button"
              className={openMenu === 'nonprog' ? 'ith__link ith__link--drop active' : 'ith__link ith__link--drop'}
              onClick={() => handleClick('nonprog')}
            >
              Non-Programming <span className="ith__caret">▾</span>
            </button>
            <div className={openMenu === 'nonprog' ? 'ith__dropdown open' : 'ith__dropdown'}>
              <ul className="ith__dropdown-list">
                <li>
                  <Link to="/it-training/non-programming" className="ith__dropdown-link ith__dropdown-link--all" onClick={closeAll}>
                    → View All Non-Programming Courses
                  </Link>
                </li>
                {nonProgrammingCourses.map(c => <DropItem key={c.title} item={c} basePath="/it-training/non-programming" />)}
              </ul>
            </div>
          </div>

          {/* 4. Special Training */}
          <div
            className="ith__drop-wrap"
            onMouseEnter={() => handleMouseEnter('special')}
            onMouseLeave={handleMouseLeave}
          >
            <button
              type="button"
              className={openMenu === 'special' ? 'ith__link ith__link--drop active' : 'ith__link ith__link--drop'}
              onClick={() => handleClick('special')}
            >
              Special Training <span className="ith__caret">▾</span>
            </button>
            <div className={openMenu === 'special' ? 'ith__dropdown open' : 'ith__dropdown'}>
              <ul className="ith__dropdown-list">
                <li>
                  <Link to="/it-training/special" className="ith__dropdown-link ith__dropdown-link--all" onClick={closeAll}>
                    → View All Special Programs
                  </Link>
                </li>
                {specialTraining.map(c => <DropItem key={c.title} item={c} basePath="/it-training/special" />)}
              </ul>
            </div>
          </div>

          {/* 5. Blog */}
          <NavLink to="/it-training/blog" className={({isActive}) => isActive ? 'ith__link active' : 'ith__link'} onClick={closeAll}>
            Blog
          </NavLink>

          {/* 6. Contact */}
          <NavLink to="/it-training/contact" className="ith__link ith__link--cta" onClick={closeAll}>
            Contact Us
          </NavLink>

        </div>
      </nav>
    </header>
  );
}

export default ITTrainingHeader;
